var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpireIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.5C12.366 15.5 15.5 12.366 15.5 8.5C15.5 4.63401 12.366 1.5 8.5 1.5C4.63401 1.5 1.5 4.63401 1.5 8.5C1.5 12.366 4.63401 15.5 8.5 15.5Z",
    fill: "#FC4848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C11.5376 14 14 11.5376 14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H9V8.5H8V4Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3277 10.4767L10.4792 11.3252L8.0752 8.92174L8.9237 8.07324L11.3277 10.4767Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5C9.05228 9.5 9.5 9.05228 9.5 8.5C9.5 7.94772 9.05228 7.5 8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5C7.5 9.05228 7.94772 9.5 8.5 9.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C8.22386 8 8 8.22386 8 8.5C8 8.77614 8.22386 9 8.5 9Z",
    fill: "#FC4848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95009 21.0004L13.1501 8.95039C13.5501 8.30039 14.5001 8.30039 14.8501 8.95039L22.0501 21.0004C22.4501 21.6504 21.9501 22.5004 21.2001 22.5004H6.80009C6.05009 22.5004 5.55009 21.6504 5.95009 21.0004Z",
    fill: "#F4C20D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 19.95C13.2002 19.85 13.2002 19.75 13.2502 19.65C13.3002 19.55 13.3502 19.5 13.4002 19.4C13.4502 19.3 13.5502 19.3 13.6502 19.25C13.7502 19.2 13.8502 19.2 13.9502 19.2C14.0502 19.2 14.2002 19.2 14.3002 19.25C14.4002 19.3 14.5002 19.35 14.5502 19.4C14.6002 19.45 14.6502 19.55 14.7002 19.65C14.7502 19.75 14.7502 19.85 14.7502 19.95C14.7502 20.05 14.7502 20.15 14.7002 20.25C14.6502 20.35 14.6002 20.4 14.5502 20.5C14.5002 20.6 14.4002 20.6 14.3002 20.65C14.2002 20.7 14.1002 20.7 13.9502 20.7C13.8002 20.7 13.7002 20.7 13.6502 20.65C13.6002 20.6 13.4502 20.55 13.4002 20.5C13.3502 20.45 13.3002 20.35 13.2502 20.25C13.2002 20.15 13.2002 20.05 13.2002 19.95ZM14.6002 18.4H13.4502L13.2502 13.5H14.7502L14.6002 18.4Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpireIcon);
export default __webpack_public_path__ + "static/media/expire-icon.ee0b1757ab563ca1b6cff1479ad43448.svg";
export { ForwardRef as ReactComponent };